import { Autocomplete, Menu, Button, Paper, Text, Box, Flex, Group } from '@mantine/core'
import classes from './ManageProduct.module.css'
import { IoAdd } from "react-icons/io5";
import { IoMdSearch } from "react-icons/io";
import { PiDotsThreeOutlineFill } from "react-icons/pi";
import React, { memo, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import TableProductDataComponent from './TableProductData.component';


const ManageProduct = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [sendsearch, setSendsearch] = useState('');

  const handlechange = (value: any) => {
    setSearch(value);
  };
  

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSendsearch(search);
    }, 500); // Debounce input for better performance

    return () => clearTimeout(timeout); // Cleanup on re-renders
  }, [search]);

  return (
    <>

      <Paper shadow="xs" p="xs" radius="md">
        <Box>
          <Flex
            style={{ justifyContent: 'space-between' }}
            align="center"
          >
            <Box>
              <Text ta="left">Products</Text>
            </Box>
            <Group >
              <Autocomplete
                // label="Your favorite library"
                placeholder="Search by Product name"
                leftSection={<IoMdSearch />}
                onChange={handlechange}
              />

              <Button
                className={classes.addbtn}
                variant="gradient"
                gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                leftSection={<IoAdd size={20} />}
                onClick={() => navigate('/manage-products/addproduct')}
              >
                Add Product
              </Button>
              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <Button variant="default"><PiDotsThreeOutlineFill /></Button>
                </Menu.Target>
              </Menu>
            </Group>
          </Flex>
          <TableProductDataComponent editLink={'/manage-products/addproduct'} search={sendsearch} />
        </Box>
      </Paper>
    </>
  )
}

export default memo(ManageProduct)
